import {
  BarChart3,
  Percent,
  PieChart,
  RefreshCcw,
  Target,
  TrendingDown,
  TrendingUp,
  Wallet,
} from "lucide-react";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { formatCurrency } from "../../../lib/utils";
import { Driver } from "../@types";

interface VehicleFinanceCardProps {
  driver: Driver;
}

const DriverFinanceCard02: React.FC<VehicleFinanceCardProps> = ({ driver }) => {
  const cards = [
    // ===== GLOBAL DRIVER STATS =====
    {
      label: "Total Earnings",
      value: formatCurrency(driver.totalEarning),
      icon: <TrendingUp className="h-8 w-8 text-green-500" />,
    },
    {
      label: "Total Distance",
      value: `${driver.totalDistance.toLocaleString()} km`,
      icon: <BarChart3 className="h-8 w-8 text-blue-500" />,
    },
    {
      label: "Total Fines",
      value: formatCurrency(driver.totalFine),
      icon: <TrendingDown className="h-8 w-8 text-red-500" />,
    },
    {
      label: "Total Incidents",
      value: driver.totalIncident,
      icon: <PieChart className="h-8 w-8 text-orange-500" />,
    },
    {
      label: "Total Accidents",
      value: driver.totalAccident,
      icon: <RefreshCcw className="h-8 w-8 text-purple-500" />,
    },
    {
      label: "Income Target",
      value: formatCurrency(driver.incomeTarget),
      icon: <Target className="h-8 w-8 text-yellow-500" />,
    },

    // ===== CURRENT ASSIGNMENT =====
    {
      label: "Current Income",
      value: formatCurrency(driver.currentAssignmentIncome),
      icon: <TrendingUp className="h-8 w-8 text-green-600" />,
    },
    {
      label: "Current Distance",
      value: `${driver.currentAssignmentDistance.toLocaleString()} km`,
      icon: <BarChart3 className="h-8 w-8 text-blue-600" />,
    },
    {
      label: "Current Expenses",
      value: formatCurrency(driver.currentAssignmentExpenses),
      icon: <TrendingDown className="h-8 w-8 text-red-500" />,
    },
    {
      label: "Current Fines",
      value: formatCurrency(driver.currentAssignmentFines),
      icon: <TrendingDown className="h-8 w-8 text-red-600" />,
    },
    {
      label: "Current balance",
      value: formatCurrency(driver.currentAssignmentJourneyBalance),
      icon: <Wallet className="h-8 w-8 text-primary" />,
    },
    {
      label: "Current Yield",
      value: formatCurrency(driver.currentAssignmentYield),
      icon: <BarChart3 className="h-8 w-8 text-indigo-500" />,
    },
    {
      label: "Current Fuel Cost",
      value: formatCurrency(driver.currentAssignmentFuelPurchased),
      icon: <Wallet className="h-8 w-8 text-orange-500" />,
    },
    {
      label: "Current Maintenance",
      value: formatCurrency(driver.currentAssignmentMaintenanceCost),
      icon: <RefreshCcw className="h-8 w-8 text-purple-500" />,
    },
    {
      label: "Current Incidents",
      value: driver.currentAssignmentIncidents,
      icon: <PieChart className="h-8 w-8 text-red-600" />,
    },
    {
      label: "Current Performance",
      value: driver.currentAssignmentFinancialPerformance,
      icon: <Percent className="h-8 w-8 text-teal-600" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 bg-white rounded-[10px] p-4 gap-4">
      {cards.map(({ label, value, icon }, index) => (
        <DashboardCard
          key={index}
          icon={icon}
          value={value}
          label={label}
          width="w-[186px] max-sm:w-full"
        />
      ))}
    </div>
  );
};

export default DriverFinanceCard02;
